

class SkinQuiz extends HTMLElement {
  constructor() {
    super();
    this.currentStep = 0;
    this.answers = {};
    this.questionCount = parseInt(this.dataset.questionCount) || 0;
    this.resultCount = parseInt(this.dataset.resultCount) || 0;
    this.progressTemplate = this.dataset.progressTemplate || 'Question [current] of [total]';
    
    this.stage = this.querySelector('[data-quiz-stage]');
    this.intro = this.querySelector('[data-quiz-intro]');
    this.steps = this.querySelectorAll('[data-quiz-step]');
    this.results = this.querySelectorAll('[data-quiz-result-panel]');
    this.progress = this.querySelector('[data-quiz-progress]');
    this.progressLabel = this.querySelector('[data-quiz-progress-label]');
    this.segments = this.querySelectorAll('[data-quiz-segment]');
    
    this.startBtn = this.querySelector('[data-quiz-start]');
    this.backBtns = this.querySelectorAll('[data-quiz-back]');
    this.restartBtns = this.querySelectorAll('[data-quiz-restart]');
    this.optionBtns = this.querySelectorAll('[data-quiz-option]');
    
    this.bindEvents();
  }

  bindEvents() {
    if (this.startBtn) {
      this.startBtn.addEventListener('click', () => this.startQuiz());
    }
    
    this.backBtns.forEach(btn => {
      btn.addEventListener('click', () => this.goBack());
    });
    
    this.restartBtns.forEach(btn => {
      btn.addEventListener('click', () => this.restartQuiz());
    });
    
    this.optionBtns.forEach(btn => {
      btn.addEventListener('click', (e) => this.selectOption(e));
    });
  }

  startQuiz() {
    this.intro.hidden = true;
    this.intro.classList.remove('is-active');
    this.currentStep = 1;
    this.answers = {};
    this.showStep(1);
    if (this.progress) this.progress.hidden = false;
    this.updateProgress();
  }

  showStep(step) {
    this.steps.forEach(s => {
      s.hidden = true;
      s.classList.remove('is-active');
    });
    
    const currentStepEl = this.querySelector(`[data-quiz-step="${step}"]`);
    if (currentStepEl) {
      currentStepEl.hidden = false;
      currentStepEl.classList.add('is-active');
    }
  }

  selectOption(e) {
    const btn = e.currentTarget;
    const questionIndex = btn.dataset.questionIndex;
    const optionIndex = btn.dataset.optionIndex;
    const result = btn.dataset.quizResult;
    
    this.answers[questionIndex] = {
      optionIndex: optionIndex,
      result: result,
      label: btn.querySelector('.skin-quiz__option-label')?.textContent || ''
    };
    
    // Check if this is question 1 (qualifying question)
    if (questionIndex === '1') {
      // If not Type 4, immediately show Result 3
      if (result === 'disqualify' || result === 'straight') {
        this.showResult(3);
        return;
      }
    }
    
    // Move to next question or show result
    if (this.currentStep < this.questionCount) {
      this.currentStep++;
      this.showStep(this.currentStep);
      this.updateProgress();
    } else {
      this.calculateResult();
    }
  }

  calculateResult() {
    // Check if any answer disqualifies
    const q1Answer = this.answers['1'];
    if (q1Answer && (q1Answer.result === 'disqualify' || q1Answer.result === 'straight')) {
      this.showResult(3);
      return;
    }
    
    // Calculate score from questions 2-4
    let score = 0;
    let totalQuestions = 0;
    
    for (let i = 2; i <= this.questionCount; i++) {
      const answer = this.answers[i];
      if (answer) {
        totalQuestions++;
        // Map option index to score (1 = highest concern, 4 = lowest)
        const optionScore = this.getOptionScore(answer.optionIndex);
        score += optionScore;
      }
    }
    
    // Calculate average score
    const avgScore = totalQuestions > 0 ? score / totalQuestions : 0;
    
    // Determine result based on average score
    // Lower score = more concerns = Result 1 (Strong Match)
    // Higher score = fewer concerns = Result 2 (Moderate Match)
    // Very high score = Result 3 (Lower Match)
    
    let resultIndex = 1;
    
    if (avgScore <= 2) {
      resultIndex = 1; // Strong Match
    } else if (avgScore <= 3) {
      resultIndex = 2; // Moderate Match
    } else {
      resultIndex = 3; // Lower Match
    }
    
    this.showResult(resultIndex);
  }

  getOptionScore(optionIndex) {
    // Option 1 = 1 (highest concern), Option 4 = 4 (lowest concern)
    return parseInt(optionIndex) || 1;
  }

  showResult(resultIndex) {
    this.steps.forEach(s => {
      s.hidden = true;
      s.classList.remove('is-active');
    });
    
    const resultEl = this.querySelector(`[data-quiz-result-panel="${resultIndex}"]`);
    if (resultEl) {
      resultEl.hidden = false;
      resultEl.classList.add('is-active');
    }
    
    if (this.progress) this.progress.hidden = true;
  }

  goBack() {
    if (this.currentStep > 1) {
      this.currentStep--;
      this.showStep(this.currentStep);
      this.updateProgress();
    } else {
      this.intro.hidden = false;
      this.intro.classList.add('is-active');
      this.steps.forEach(s => {
        s.hidden = true;
        s.classList.remove('is-active');
      });
      if (this.progress) this.progress.hidden = true;
    }
  }

  restartQuiz() {
    this.currentStep = 0;
    this.answers = {};
    this.intro.hidden = false;
    this.intro.classList.add('is-active');
    this.steps.forEach(s => {
      s.hidden = true;
      s.classList.remove('is-active');
    });
    this.results.forEach(r => {
      r.hidden = true;
      r.classList.remove('is-active');
    });
    if (this.progress) this.progress.hidden = true;
  }

  updateProgress() {
    if (!this.progressLabel) return;
    
    const label = this.progressTemplate
      .replace('[current]', this.currentStep)
      .replace('[total]', this.questionCount);
    
    this.progressLabel.textContent = label;
    
    this.segments.forEach((seg, index) => {
      seg.classList.toggle('is-active', index < this.currentStep);
      seg.classList.toggle('is-current', index === this.currentStep - 1);
    });
  }
}

customElements.define('skin-quiz', SkinQuiz);